export const SEASON_BACKGROUND_REQUIRED_WIDTH = 3840
export const SEASON_BACKGROUND_REQUIRED_HEIGHT = 2160
